<script lang="ts" setup generic="T extends RoutesNamesList, P extends string">
import type { NuxtRoute, RoutesNamesList } from '@typed-router'

defineProps<{
  padding?: boolean
  title?: string
  description?: string
  scrollInner?: boolean
  hideTop?: boolean
  fullHeight?: boolean
  backLink?: NuxtRoute<T, P> | (() => void)
}>()
</script>

<template>
  <div
    id="main-content"
    class="flex flex-1 flex-col max-w-full"
    :class="{ 'pt-2': padding, 'overflow-y-auto scrollbar': scrollInner !== true, '!overflow-hidden h-full': scrollInner === true }"
  >
    <div
      v-if="($slots.top || title) && hideTop !== true"
      :class="{ 'px-2 pb-2': padding }"
    >
      <slot name="top">
        <DashboardTitleBar
          v-if="title"
          :title="title"
          :description="description"
        >
          <template
            v-if="$slots.description"
            #description
          >
            <slot name="description" />
          </template>
          <template
            v-if="backLink"
            #start
          >
            <UiButton
              v-if="typeof backLink === 'function'"
              variant="ghost"
              size="icon"
              @click="backLink"
            >
              <Icon
                name="tabler-arrow-left"
                class="size-5"
              />
            </UiButton>
            <UiButton
              v-else
              :to="backLink"
              variant="ghost"
              size="icon"
            >
              <Icon
                name="tabler-arrow-left"
                class="size-5"
              />
            </UiButton>
          </template>
          <slot name="top-actions" />
        </DashboardTitleBar>
        <slot name="top-below" />
      </slot>
    </div>
    <div
      id="mainsub"
      class="flex flex-col gap-4 max-w-full relative"
      :class="{ 'px-2': padding, 'overflow-y-auto h-full scrollbar': scrollInner, 'h-full': fullHeight }"
    >
      <slot />
    </div>
  </div>
</template>
